module.exports = __webpack_public_path__ + "img/gnzs3.b0d7b50e.png";